module.exports = __webpack_public_path__ + "static/media/dut.d86383d0.jpg";